<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    การจัดการรูปภาพ
                </div>


                <div class="row search-section">
                    <div class="col-sm-2 col-search">

                        <button type="button" class="btn bg-teal waves-effect btn-search" @click="add()">
                            <i class="material-icons">add_box</i>
                            <span>เพิ่มรูปภาพหน้าหลัก</span>
                        </button>

                    </div>
                   
                   

                </div>
              
                <div class="body table-responsive" style="width:100%">
                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                  
                                    <th class="fn-th" style="width:50%">รูปภาพ</th>
                                    <th class="fn-th" style="width:30%">ลิงค์</th>
                                    <th class="fn-th" style="width:10%">แก้ไข</th>
                                    <th class="fn-th" style="width:10%">ลบ</th>
                                 
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in images" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                  
                                    <td style="text-align: center">

                                        <img :src="item.image" :alt="item.game_name"  style="width: 200px;" v-if="item.image != null"/>

                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.link }}</span>
                                    </td>

                                    <td>
                                        <span @click="edit(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon">mode_edit</i>
                                            </a>
                                        </span>
                                    </td>
                                    <td>
                                        <span @click="del(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon" style="color:red;">cancel</i>
                                            </a>
                                        </span>
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>

                
                  
                </div>
            </div>
        </div>
        <div class="modal fade" id="image-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">เพิ่มรูปภาพ</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">

                    <div class="row" style="margin-top:20px">
                        <div class=" col-sm-2"></div>
                        <div class="col-sm-10" style="text-align: center;">
                            
                             <div style="margin-top: 15px;" v-if="image.image">
                                <img :src="image.image" class="img-box" alt="i-game"/>
                                <div style="margin-top: 10px;">
                                <i class="material-icons del-image-icon" @click="deleteImage()">clear</i>
                                </div>
                             </div>
                             <div v-else>
                                <button class="file-upload-btn" type="button" @click="uploadClick()">+เพิ่มรูปภาพ</button>
                                 <input class="file-upload-input" type='file' ref="uploadFile"
                                @change="handleFilesUpload(this);" accept="image/*" />
                            </div>
                        </div>

                    </div>


                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ลิงค์</span>
                        </div>
                        <div class="col-sm-10">
                           
                            <input type="text" class="form-control fn-required" v-model="image.link" placeholder="กรุณากรอกลิงค์">
                        </div>
                    </div>

                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="handleSave()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ImageService from '../../service/ImageService'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'

export default {
    name: "ImageManage",
    components: {
        Paginate
    },
    data() {
        return {
            images: [],
            image: {},
            key: "",
            file: null,
            searching: false,
            loading: false,
        }
    },
    async created() {
        await this.getImages()
    },
    mounted() {

    },
    methods: {
        async getImages() {
            let response = await ImageService.get("main")
            if(response.status){
                this.images = response.result
            }
        },
        add() {
           
            this.image = {
                id: 0,
                image: "",
                link: ""
            }
            $('#image-modal').modal('show')
        },
        edit(id) {
            
            this.image = this.images.find(x => x.id == id)
            $('#image-modal').modal('show')
            
        },
        async handleSave() {
            if (!this.validate()) {
                return false
            }

            if (this.image.id == 0) {
                await this.create()
            }
            else {
                await this.update()
            }

            $('#image-modal').modal('hide')
        },
        validate() {
            if (!this.image.image) {
                alertBox.error("กรุณาเลือกภาพ")
                return false
            }
            
            return true
        },
        async create() {
            try {
                
                let formData = new FormData();
                formData.append('link', this.image.link);
                formData.append('type', "main");
                formData.delete('file');
                if (this.file) {
                    formData.append('file', this.file);
                }

                let response = await ImageService.create(formData)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.getImages()
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        async update() {
            try {
                let formData = new FormData();
                formData.append('id', this.image.id);
                formData.append('link', this.image.link);
                formData.delete('file');
                if (this.file) {
                    formData.append('file', this.file);
                }
                
                let response = await ImageService.update(formData)
              
                if (response.status) {
                    alertBox.success('save success')
                    this.getImages()
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        async del(id) {
            let result = await alertBox.confirm('คุณแน่ใจที่จะลบ?')
            if (result) {
                let data = {
                    id: id
                }
                let response = await ImageService.delete(data)

                if (response.status) {
                    this.getImages()
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
        },
         uploadClick(){
            this.$refs.uploadFile.click()
        },
        handleFilesUpload() {
             let uploadedFiles = this.$refs.uploadFile.files;
            this.image.image = URL.createObjectURL(uploadedFiles[0])
            this.file = uploadedFiles[0]
            this.$refs.uploadFile.value = ""
        },
        validateFile(file) {
            
            if (file.size > this.max_file_size) {
                let size = this.max_file_size / 1000000
                alertBox.error(`กรุณาเลือกขนาดขนาดไฟล์ ไม่เกิน ${size} mb`)
                return false
            }

            if (!file.type) {
                alertBox.error(`ชนิดของไฟล์ไม่ถูกต้อง<br>ไม่อนญาตไฟล์ ${file.name} ขึ้นสู่ระบบ`)
                return false
            }

            let ext = file.name.split('.').reverse()[0].toLowerCase()
            if (!this.file_extensions.includes(ext)) {
                alertBox.error(`ชนิดของไฟล์ไม่ถูกต้อง<br>ไม่อนญาตไฟล์ ${file.name} ขึ้นสู่ระบบ`)
                return false
            }

            return true
        },
        async deleteImage() {
            const result = await alertBox.confirm('Are you sure to delete?')
            
            if (result) {
                this.image.image = ""
            }

        },

    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped>
.clear-img{
        cursor: pointer;
        color:red;
        font-size:16px;
        vertical-align: middle;
    }
    .img-box{
        cursor: zoom-in;
        max-height : 160px;
    }
    
    .file-upload {
        background-color: #ffffff;
        width: 600px;
        margin: 0 auto;
        padding: 20px;
    }

    .file-upload-btn {
        width: 100%;
        color: #2196f3;
        background: #fff;
        border: 1px dashed #2196f3;
        padding: 10px;
        border-radius: 4px;
        /* border-bottom: 4px solid #15824B; */
        transition: all .2s ease;
        outline: none;
        text-transform: uppercase;
        font-weight: 700;
    }

    .file-upload-btn:hover {
        background: #2196f3;
        color: #ffffff;
        transition: all .2s ease;
        cursor: pointer;
    }

    .file-upload-btn:active {
        border: 0;
        transition: all .2s ease;
    }

    .file-upload {
        background-color: #ffffff;
        width: 600px;
        margin: 0 auto;
        padding: 20px;
    }

    .file-upload-content {
        display: none;
        text-align: center;
    }

    .file-upload-input {
        position: absolute;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        outline: none;
        opacity: 0;
        cursor: pointer;
    }   

    .image-title-wrap {
        padding: 0 15px 15px 15px;
        color: #222;
    }

    .file-upload-image {
        max-height: 200px;
        max-width: 200px;
        margin: auto;
        padding: 20px;
    }
    .del-image-icon{
        color: red;
        cursor: pointer;
        font-size: 21px;
    }
   
</style>


// WEBPACK FOOTER //
// src/components/Manage/Image.vue